<ng-container *transloco="let t">
    <div class="reset-password-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()">
                    <div class="title text-center">
                        <h3>
                            {{t('reset-password?')}}
                        </h3>
                        <p class="ml-auto mr-auto">
                            {{t('enter-your-new-password')}}
                        </p>
                    </div>
                    <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('password')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-password')}}
                                </mat-label>
                                <input matInput [type]="hide ? 'password' : 'text'" id="password"
                                    formControlName="password" required>
                                <button mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <span class="material-symbols-outlined">
                                        {{hide ? 'visibility_off' : 'visibility'}}
                                    </span>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('confirm-password')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('confirm-password')}}
                                </mat-label>
                                <input matInput [type]="hide2 ? 'password' : 'text'" id="confirmPassword"
                                    formControlName="confirmPassword" required>
                                <button mat-icon-button matSuffix (click)="hide2 = !hide2"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                                    <span class="material-symbols-outlined">
                                        {{hide2 ? 'visibility_off' : 'visibility'}}
                                    </span>
                                </button>
                            </mat-form-field>
                        </div>
                        <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                            {{t('send')}}
                        </button>
                        <div class="text-center back-to-sign-in">
                            <a mat-button routerLink="/authentication">
                                <i class="ri-arrow-left-s-line"></i>
                                {{t('back-to')}} {{t('sign-in')}}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-container>
